import { getToken, removeToken } from '@/utils/storage'
import axios from 'axios';
import { Loading, Message, MessageBox } from "element-ui";
import { Toast } from 'vant';
import { promptLoginOnce } from '@/utils/authGuard'
const APP_ID = 10001
// 未登录可访问接口白名单（与 web 端保持一致，按"接口路径前缀"匹配）
const PUBLIC_API_PREFIXES = [
    // 登录/注册/协议
    '/user.user/login',
    '/user.user/register',
    '/user.user/reset_password',
    '/user/register',
    // 发送验证码（注册/找回密码）
    '/user.userOpen/sendCode',
    // 店铺/Services（公开）
    '/service.service/category_list',
    '/service.service/supplier_list',
    '/service.service/supplier_detail',
    // 商家公开内容
    '/supplier.index/getSupplierComment',
    '/supplier.index/getSupplierCard',
    '/supplier.index/getCardDetail',
    '/supplier.index/share',
    // SearchServices可用技师
    '/technician.technician/getAvailableTechnicians',
]
const normalizeApiUrl = (url) => {
    if (!url) return ''
    // mobile 里多为 "/api/xxx.xxx/yyy"：统一去掉前缀 "/api"
    const u = String(url)
    const path = u.split('?')[0]
    return path.replace(/^\/api/, '')
}
const isPublicApi = (url) => {
    const path = normalizeApiUrl(url)
    if (!path) return true
    return PUBLIC_API_PREFIXES.some(prefix => path.startsWith(prefix))
}
const injectAppIdIntoBody = (config) => {
    // Only inject when request has a body (axios: config.data).
    const data = config && config.data
    if (!data) return
    // multipart/form-data (file upload / FormData)
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
        // Avoid duplicate keys: use has/get when available.
        const has = (typeof data.has === 'function') ? data.has('app_id')
            : (typeof data.get === 'function' ? (data.get('app_id') !== null) : false)
        if (!has) data.append('app_id', APP_ID)
        return
    }
    // application/x-www-form-urlencoded (URLSearchParams)
    if (typeof URLSearchParams !== 'undefined' && data instanceof URLSearchParams) {
        if (!data.has('app_id')) data.set('app_id', String(APP_ID))
        return
    }
    // Plain object JSON body
    if (typeof data === 'object' && !Array.isArray(data)) {
        // Skip binary-ish payloads to avoid corrupting uploads.
        if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return
        if (typeof Blob !== 'undefined' && data instanceof Blob) return
        if (typeof File !== 'undefined' && data instanceof File) return
        if (typeof data.app_id === 'undefined' || data.app_id === null) {
            data.app_id = APP_ID
        }
    }
}
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/index.php',
});
var Toast1 = null
service.interceptors.request.use(
    (config) => {
        // 先做登录校验：未登录访问受保护接口时，直接弹窗并阻止请求
        // 注意：axios request 拦截器是“后注册的先执行”（LIFO），这里合并成一个拦截器避免顺序问题
        if (!getToken() && !isPublicApi(config.url)) {
            try {
                if (Toast1 && typeof Toast1.clear === 'function') Toast1.clear()
            } catch (e) {}
            Toast1 = null
            const redirect = window.location.hash ? window.location.hash.replace(/^#/, '') : '/'
            promptLoginOnce(redirect)
            const err = new Error('')
            err._shown = true
            err._authRequired = true
            return Promise.reject(err)
        }
        // 通过校验后再展示 loading（否则 forbidClick 会导致弹窗按钮不可点）
        Toast1 = Toast.loading({
            duration: 0,
            message: 'Loading...',
            forbidClick: true,
            loadingType: 'spinner',
        })
        if (!config.params) {
            config.params = {};
        }
        config.params.app_id = APP_ID
        injectAppIdIntoBody(config)
        // 只要当前已登录，就为请求补上 token。
        // 这样像 supplier_detail 这类公开接口也能返回当前用户视角的数据（例如 is_favorite）。
        const token = getToken()
        if (token) {
            config.params.token = token
        }
        return config;
    },
    (error) => {
        try {
            if (Toast1 && typeof Toast1.clear === 'function') Toast1.clear()
        } catch (e) {}
        Toast1 = null
        Message.error({
            message: 'Network is unstable, please try again later'
        })
        return Promise.reject(error);
    }
);
service.interceptors.response.use(
    (response) => {
        if (response.headers !== "application/octet-stream") {
            try {
                if (Toast1 && typeof Toast1.clear === 'function') Toast1.clear()
            } catch (e) {}
            Toast1 = null
            // 兼容后端：未登录/缺 token 时，提示登录并拦截后续逻辑
            const res = response.data || {}
            const msg = res.msg || res.message || ''
            const code = res.code
            // code=-1/-2/-3：直接判定为 auth 错误，清除旧 token，不依赖消息文本
            const isAuthCode = (code === -1 || code === -2 || code === -3)
            // 兜底：code=0/401 但消息命中正则（向后兼容）
            const maybeAuthError = !isAuthCode &&
                (code === 0 || code === 401 || code === '401') &&
                /log in|not logged in|token|please log in|未登录|请先登录/i.test(String(msg))
            if (isAuthCode || maybeAuthError) {
                removeToken()
                const redirect = window.location.hash ? window.location.hash.replace(/^#/, '') : '/'
                promptLoginOnce(redirect)
                const err = new Error(msg || '')
                err._shown = true
                err._authRequired = true
                return Promise.reject(err)
            }
            return res;
        } else {
            const res = response.data;
            if (res.code !== 200) {
                try {
                    if (Toast1 && typeof Toast1.clear === 'function') Toast1.clear()
                } catch (e) {}
                Toast1 = null
                Message({
                    message: res.message,
                    type: "error",
                    duration: 3 * 1000,
                });
                if (res.code === 401) {
                    MessageBox.confirm(
                        "You have been logged out. You can stay on this page or log in again.",
                        "Confirm Logout", {
                            confirmButtonText: "Log In Again",
                            cancelButtonText: "Cancel",
                            type: "warning",
                        }
                    ).then(() => {
                        location.reload();
                    });
                }
                return Promise.reject("error");
            } else {
                try {
                    if (Toast1 && typeof Toast1.clear === 'function') Toast1.clear()
                } catch (e) {}
                Toast1 = null
                return response.data;
            }
        }
    },
    (error) => {
        // 对于“未登录被拦截”的场景（我们已经弹过 Dialog），不要再弹 element-ui 的 Message，
        // 否则会出现顶部空白红框（error.message 为空）
        if (error && (error._shown || error._authRequired)) {
            return Promise.reject(error);
        }
        try {
            if (Toast1 && typeof Toast1.clear === 'function') Toast1.clear()
        } catch (e) {}
        Toast1 = null
        const msg = (error && error.message) ? String(error.message).trim() : ''
        if (msg) {
            Message({
                message: msg,
                type: "error",
                duration: 3 * 1000,
            });
        }
        return Promise.reject(error);
    }
);
export default service;
